import { defineMessages } from "react-intl";

import {
	validator,
	valueMessages
} from "lib/build/forms/htx/current-cardiological-state/pacemakerTherapy";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	pacemakerTherapy: {
		id: "form.pacemaker_therapy",
		defaultMessage: "Pacemaker kezelés"
	},
	value: {
		id: "form.pacemaker_therapy.value",
		defaultMessage: "Érték"
	}
});

const fields: { [key: string]: FieldData } = {
	value: {
		type: "field",
		path: ["value"],
		label: messages.value,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: valueMessages } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.value }] }]
};

export const node: LeafNode = {
	id: "pacemakerTherapy",
	value: {
		title: messages.pacemakerTherapy,
		validator,
		fieldset,
		isImportant: true,
		applyCurrentDate: true
	}
};
